import { render, staticRenderFns } from "./joinsuccess.vue?vue&type=template&id=74ea25fc&scoped=true"
import script from "./joinsuccess.vue?vue&type=script&lang=js"
export * from "./joinsuccess.vue?vue&type=script&lang=js"
import style0 from "./joinsuccess.vue?vue&type=style&index=0&id=74ea25fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea25fc",
  null
  
)

export default component.exports